import type { ReactNode } from 'react';
export interface ConsultationActivityDisplay {
  readonly actorDisplayName?: string | null;
  readonly actorStaffUserId?: number;
  readonly actorRole: string;
  readonly reason?: string | null;
  readonly occurredAt: string;
  readonly reference?: string | null;
}
export function consultationDateTime(value: string): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'Date unavailable';
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
  const part = (type: string) => parts.find(p => p.type === type)?.value ?? '';
  return `${part('day')} ${part('month')}, ${part('hour')}:${part('minute')} IST`;
}
const roles: Record<string,string> = {doctor:'Doctor',receptionist:'Reception',coc:'COC',call_center_agent:'Call Center',owner:'Owner',regional_head:'Regional head',gm_agm:'GM/AGM'};
export function ConsultationAttribution({label,activity}: {label:string;activity:ConsultationActivityDisplay}): ReactNode {
  const actor=activity.actorDisplayName?.trim() || (activity.actorStaffUserId ? `Staff #${activity.actorStaffUserId}` : 'Actor unavailable');
  return <div><p>{label} by {actor} · {roles[activity.actorRole] ?? activity.actorRole} · {consultationDateTime(activity.occurredAt)}</p>
    {activity.reason||activity.reference?<details><summary>Details</summary>{activity.reason?<p>{activity.reason}</p>:null}{activity.reference?<p>Ref {activity.reference}</p>:null}</details>:null}
  </div>;
}
